import { useMemo, useState } from 'react';

import { SelectedEntity } from '../components';

interface UseTenantDefaultsSelectionProps<T extends { userId: string | null }> {
  tenantDefaults: T[];
  userDefaults: T[];
}

export const useTenantDefaultsSelection = <
  T extends { userId: string | null },
>({
  tenantDefaults,
  userDefaults,
}: UseTenantDefaultsSelectionProps<T>) => {
  const [selectedEntity, setSelectedEntity] = useState<SelectedEntity>({
    type: 'org',
  });
  const [selectedOutputType, setSelectedOutputType] = useState<string | null>(
    null,
  );

  // Get defaults for the selected entity
  const selectedDefaults = useMemo(() => {
    if (selectedEntity.type === 'org') {
      return tenantDefaults;
    }
    return userDefaults.filter((d) => d.userId === selectedEntity.userId);
  }, [selectedEntity, tenantDefaults, userDefaults]);

  // Reset selection when changing entity
  const handleSelectEntity = (entity: SelectedEntity) => {
    setSelectedEntity(entity);
    setSelectedOutputType(null);
  };

  return {
    selectedEntity,
    selectedOutputType,
    setSelectedOutputType,
    selectedDefaults,
    handleSelectEntity,
  };
};
